import {actionTypes} from './constants'

export const fetchApplications = () => ({
  type: actionTypes.FETCH_APPLICATIONS_REQUESTED
})

export const fetchAudienceTypes = () => ({
  type: actionTypes.FETCH_AUDIENCE_TYPES_REQUESTED
})

export const fetchCourseStandards = () => ({
  type: actionTypes.FETCH_COURSE_STANDARDS_REQUESTED
})

export const fetchFeatures = () => ({
  type: actionTypes.FETCH_FEATURES_REQUESTED
})

export const fetchIndustries = () => ({
  type: actionTypes.FETCH_INDUSTRIES_REQUESTED
})

export const fetchOrganizationTypes = () => ({
  type: actionTypes.FETCH_ORGANIZATION_TYPES_REQUESTED
})

export const fetchObjectives = () => ({
  type: actionTypes.FETCH_OBJECTIVES_REQUESTED
})

export const editApplicationBegin = id => ({
  type: actionTypes.EDIT_APPLICATION_BEGIN,
  payload: {
    id
  }
})

export const resetEditState = () => ({
  type: actionTypes.RESET_EDIT_STATE
})

export const editApplicationChange = changes => ({
  type: actionTypes.EDIT_APPLICATION_CHANGE,
  payload: {
    ...changes
  }
})

export const savePlaylistItemOrder = newList => ({
  type: actionTypes.SAVE_PLAYLIST_ITEM_ORDER_REQUESTED,
  payload: newList
})

export const saveApplication = () => ({
  type: actionTypes.SAVE_APPLICATION_REQUESTED
})

export const deleteApplication = () => ({
  type: actionTypes.DELETE_APPLICATION_REQUESTED
})

export const addToUploadQueue = upload => ({
  type: actionTypes.UPLOAD_FILE_REQUESTED,
  payload: upload
})

export const savePlaylistItem = playlistItem => ({
  type: actionTypes.SAVE_PLAYLIST_ITEM_REQUESTED,
  payload: playlistItem
})

export const trackPlaylistItemView = playlistItem => ({
  type: actionTypes.TRACK_PLAYLIST_ITEM_VIEW_REQUESTED,
  payload: playlistItem
})

export const fetchPlaylistItemViews = (payload) => ({
  type: actionTypes.FETCH_PLAYLIST_ITEM_VIEWS_REQUESTED,
  payload
})
export const editPlaylistItem = playlistItem => ({
  type: actionTypes.EDIT_PLAYLIST_ITEM_REQUESTED,
  payload: playlistItem
})

export const deletePlaylistItem = id => ({
  type: actionTypes.DELETE_PLAYLIST_ITEM_REQUESTED,
  payload: id
})

export const viewApplicationDetails = id => ({
  type: actionTypes.FETCH_APPLICATION_DETAIL_REQUESTED,
  payload: {
    id
  }
})

export const viewApplicationContactInfo = id => ({
  type: actionTypes.VIEW_APPLICATION_CONTACT_INFO,
  payload: {
    id
  }
})

export const websiteLinkVisited = id => ({
  type: actionTypes.WEBSITE_LINK_VISITED,
  payload: {
    id
  }
})

export const scheduleDemoClicked = id => ({
  type: actionTypes.SCHEDULE_DEMO_CLICKED,
  payload: {
    id
  }
})

export const addSystemsToCompareList = ids => ({
  type: actionTypes.ADD_SYSTEMS_TO_COMPARE_LIST,
  payload: {
    ids
  }
})

export const removeSystemsFromCompareList = ids => ({
  type: actionTypes.REMOVE_SYSTEMS_FROM_COMPARE_LIST,
  payload: {
    ids
  }
})

export const compareSystems = compareIds => ({
  type: actionTypes.COMPARE_SYSTEMS,
  payload: {
    ids: compareIds
  }
})
